import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=78ddc70e"
import script from "./Memo.vue?vue&type=script&lang=js"
export * from "./Memo.vue?vue&type=script&lang=js"
import style0 from "./Memo.vue?vue&type=style&index=0&id=78ddc70e&prod&lang=less"
import style1 from "./Memo.vue?vue&type=style&index=1&id=78ddc70e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports